import { jsx as e } from "react/jsx-runtime";
import "react";
var t = (l) => /* @__PURE__ */ e("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 36 36",
  ...l,
  children: /* @__PURE__ */ e("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M11.778 13.334a6.222 6.222 0 1 1 12.444 0 6.222 6.222 0 0 1-12.444 0Zm12.17 7.19a9.332 9.332 0 1 0-11.898 0C7.09 22.273 4 26.163 4 30.445a1.556 1.556 0 0 0 3.111 0c0-3.53 3.663-7.777 10.889-7.777 7.226 0 10.889 4.246 10.889 7.777a1.556 1.556 0 0 0 3.111 0c0-4.282-3.086-8.172-8.052-9.92Z",
    clipRule: "evenodd"
  })
});
export {
  t as default
};
